import { ActivityPaymentStatus, ActivityPaymentStatusName, ActivityService, handleServerValidation } from 'ac-ui-core-local';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

export interface ActivityPaymentStatusDialogModel {
	eventId: number;
	activityId: number;
	status: ActivityPaymentStatus;
	totalCost: number;
	currencyCode: string;
}

@Component({
	templateUrl: './activity-payment-status-dialog.component.html',
	styleUrls: ['./activity-payment-status-dialog.component.scss']
})
export class ActivityPaymentStatusDialogComponent implements OnInit {
	public displayStatus: string;
	public isSubmitting: boolean;
	public form: FormGroup;
	public noCost: boolean;

	constructor(private _fb: FormBuilder, private _as: ActivityService, private dialogRef: MatDialogRef<boolean>,
		@Inject(MAT_DIALOG_DATA) public data: ActivityPaymentStatusDialogModel) {
	}

	ngOnInit() {
		this.noCost = this.data.status === ActivityPaymentStatus.NotCharged;

		this.form = this._fb.group({ totalCost: this.noCost ? 0 : null, notes: null });
		this.displayStatus = ActivityPaymentStatusName(this.data.status);
	}

	async onSubmit(form: any, isValid: boolean) {
		if (!isValid) return;

		this.isSubmitting = true;

		try {
			const totalCost = this.data.totalCost === form.totalCost ? null : form.totalCost;

			await this._as.updateActivityPaymentStatus(this.data.eventId, this.data.activityId,
				this.data.status, totalCost, form.notes);

			this.dialogRef.close({
				totalCost: form.totalCost,
				notes: form.notes
			});
		} catch (error) {
			this.isSubmitting = false;
			// todo: handle error
			alert(handleServerValidation(error));
			console.log(error);
		}
	}
}
